export const DEFAULT_SLIDE_SIZE = 380; // in px
